import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';
import { TrophyVariantOutline } from 'mdi-material-ui';

import { SidebarMenuItem } from '../SidebarMenuItem';
import { useTranslator } from '../../i18n/useTranslator';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles>;

const FinanceCoordinatorSidebarContentComponent: React.FunctionComponent<Props> = () => {
  const { t } = useTranslator();

  return (
    <div>
      <SidebarMenuItem icon={TrophyVariantOutline} label={t('competitions')} to={'/finance-coordinator/competitions'} />
    </div>
  );
};

export const FinanceCoordinatorSidebarContent = withStyles(styles)(FinanceCoordinatorSidebarContentComponent);
